import { render, staticRenderFns } from "./ContinuarButton.vue?vue&type=template&id=2d243021&scoped=true&"
import script from "./ContinuarButton.vue?vue&type=script&lang=ts&"
export * from "./ContinuarButton.vue?vue&type=script&lang=ts&"
import style0 from "./ContinuarButton.vue?vue&type=style&index=0&id=2d243021&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d243021",
  null
  
)

export default component.exports